export class StudentNewsModel {
	title: string;
	body: string;
	thumbnail: string;
	image_placement: string;
}
